export const ADD_SCENE = '@@createScene/addScene'

export const RESET_CREATE_SCENE = '@@createScene/reset'
